// extracted by mini-css-extract-plugin
export default {"attachmentCellRoot":"AttachmentCell_attachmentCellRoot__2CN2O"};